// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPhoneVoicemail = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M3 12a4 4 0 004 4h10a4 4 0 10-3.465-2h-3.07A4 4 0 103 12m14 2a2 2 0 100-4 2 2 0 000 4m-8-2a2 2 0 11-4 0 2 2 0 014 0"
    />
  );
export default SvgIconPhoneVoicemail;
